import { adminClient } from "better-auth/client/plugins";
import { createFluentryAuthClient } from "@fluentry/shared-workbench/auth";
import { API_BASE_URL } from "./api";

// Keep the admin auth client on the shared factory so plugin differences stay declarative instead of per-app boilerplate.
export const authClient = createFluentryAuthClient({
  baseURL: API_BASE_URL,
  plugins: [adminClient()],
});
